import Image from 'next/image';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { Pill } from '@/components/base/Pill';

type SparksHeaderProps = {
    onMinimize: () => void;
    onNewChat: () => void;
};

export function SparksHeader({ onMinimize, onNewChat }: SparksHeaderProps) {
    const { t } = useTranslation('sparks');

    return (
        <div className="flex w-full shrink-0 items-center justify-between border-b border-icoGray-300 px-3.5 py-3 dark:border-icoDarkMode-beton">
            <div className="flex items-center gap-1.5">
                <div className="relative flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-icoGray-300 p-1 shadow-icoXS dark:bg-icoDarkMode-anthracite">
                    <Image
                        src="/images/svg/sparks-avatar.svg"
                        alt="Sparks"
                        width={24}
                        height={24}
                        className="absolute bottom-[-4px] right-[-4px] size-6 object-contain"
                    />
                </div>
                <span className="font-GSemiBold text-xs tracking-tight text-icoBlack dark:text-white">
                    {t('title')}
                </span>
                <Pill variant="warning" className="dark:bg-icoYellow/15 dark:text-icoYellow">
                    {t('beta')}
                </Pill>
            </div>
            <div className="flex items-center gap-3.5">
                {/* Coming soon (v2) */}
                {/* <button
                    type="button"
                    onClick={onNewChat}
                    aria-label={t('new_chat')}
                    className={classNames(
                        'flex items-center justify-center text-icoGray-500',
                        'transition-colors hover:text-icoBlack'
                    )}>
                    <Icon icon="edit" className="text-[14px]" />
                </button> */}
                <button
                    type="button"
                    onClick={onMinimize}
                    aria-label={t('minimize')}
                    className="flex items-center justify-center font-GSemiBold text-icoBlack transition-colors hover:text-icoGray-500 dark:text-white dark:hover:text-icoDarkMode-wolf">
                    <span className="text-base leading-none" aria-hidden>
                        −
                    </span>
                </button>
            </div>
        </div>
    );
}
